import { useProfile } from '@/hooks/useProfile';
import { useState } from 'react';
import { HamburgerIcon } from './HamburgerIcon';
import { PROFILE_MR_EMPLOYEE_SUBTABS, PROFILE_PUBLIC_SUBTABS, TABS } from './navbar-data';
import { NavbarLogo } from './NavbarLogo';
import { NavbarMobileMenu } from './NavbarMobileMenu';

interface NavbarMobileProps {
  isAuthenticated: boolean;
}

export const NavbarMobile = ({ isAuthenticated }: NavbarMobileProps) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { isMarshallReddickEmployee } = useProfile();

  return (
    <>
      <nav className={`navbar navbar-mobile ${menuOpen ? 'navbar-mobile-menu-open' : ''}`}>
        <div className="navbar-container">
          <NavbarLogo />
          <button
            type="button"
            className="navbar-hamburger"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          >
            <HamburgerIcon />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="navbar-mobile-overlay">
          <div className="navbar-mobile-overlay-content">
            <NavbarMobileMenu
              tabs={TABS}
              isAuthenticated={isAuthenticated}
              profileSubtabs={[
                ...PROFILE_PUBLIC_SUBTABS,
                ...(isMarshallReddickEmployee ? PROFILE_MR_EMPLOYEE_SUBTABS : []),
              ]}
              onLinkClick={() => setMenuOpen(false)}
            />
          </div>
        </div>
      )}
    </>
  );
};
